import { render } from "./AuthPage.vue?vue&type=template&id=adc122be"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"
script.render = render

export default script